import React, { useState } from 'react'
import ChatUserList from '../../../components/chat/ChatUserList'
import ChatRoom from '../../../components/chat/ChatRoom'
import { useAdminStore } from '../../../store/userStore';

const AdminChattingMain = () => {
  // zustand
  const { adminInfo } = useAdminStore(state => state)

  const [tab, setTab] = useState('userList') // 사용자 목록 | 채팅방 목록 탭
  const [roomId, setRoomId] = useState('') // 채팅방 id
  const [receiverInfo, setReceiverInfo] = useState('')

  return (
    <div className="container-fluid">
      {/* Page Heading */}
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0">채팅</h1>
      </div>

      {/* Page Tab */}
      {/* <div className='mb-5'>
        <ul className="nav nav-pills">
          <li className="nav-item">
            <button type='button' className={tab === 'userList' ? 'nav-link active' : 'nav-link'} onClick={() => { setTab('userList') }}>사용자 목록</button>
          </li>
          <li className="nav-item">
            <button type='button' className={tab === 'chatList' ? 'nav-link active' : 'nav-link'} onClick={() => { setTab('chatList') }}>채팅방 목록</button>
          </li>
        </ul>
      </div> */}

      {/* Page Content */}
      <div className="">
        <div className="card shadow mb-4">
          <div className="card-body" style={{ minHeight: "calc(100vh - 350px)", overflowX: "auto" }}>

            <div className='d-flex' style={{ border: "1px solid #ddd" }}>
              <div>
                {/* {tab === 'userList' && <ChatUserList setRoomId={setRoomId} setReceiverInfo={setReceiverInfo} />} */}
                {!roomId && <ChatUserList setRoomId={setRoomId} myInfo={adminInfo} setOtherInfo={setReceiverInfo} isAdmin={true} />}
                {
                  // tab === 'chatList' &&
                  // <ChatRoomList
                  //   chatRooms={mockChatRooms}
                  //   activeRoomId={activeRoomId}
                  //   onSelectRoom={handleSelectRoom}
                  // />
                }
              </div>

              {
                roomId
                  ? <ChatRoom roomId={roomId} setRoomId={setRoomId} senderInfo={adminInfo} receiverInfo={receiverInfo} />
                  : <div className='d-flex w-100 justify-content-center align-items-center'>채팅방을 선택해주세요.</div>
              }
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminChattingMain